import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { DeleteOutlined, NavigateBefore, NavigateNext } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import {  obtenerRegistrosPorURL, setearDatosAlStore } from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import Modal from 'components/Modales/ModalDeConfirmacion';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { functions } from 'constantes/functions';
import TablaPersonalizada from 'components/TablaPersonalizada';
import { tipoDeMedio } from 'constantes/globalsStates';
let dataToValidate = [];

const TarifarioYDisponibilidad = ({activeStep, numberStep, handleClose, tarifarioYDisponibilidad, tipoMedio, title=null, subtitle=null, titleDisponibilidad=null}) => {
    const dispatch = useDispatch();
    const {nuevoTarifario} = useSelector((state) => state);
    const [catalogoDeEspaciosPorAsignar] = useState('catalogoDeEspaciosPorAsignar');
    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false),
    [datosDelElemento, setDatosDelElemento] = useState({}),
    [mostrarEliminarElemento, setMostrarEliminarElemento] = useState(false);
    const { julio, agosto, septiembre, octubre, noviembre, diciembre, promedio, disponibilidades } = tarifarioYDisponibilidad;
    const[listadoDeDisponibilidades, setListadoDeDisponibilidades] = useState(disponibilidades);
    dataToValidate = listadoDeDisponibilidades;

    const [header] = useState([
        { title: 'Fecha desde', field: 'fechaDesde', render: (rowData) => functions.FormatearFecha(rowData.fechaDesde || "")},
        { title: 'Fecha hasta', field: 'fechaHasta', render: (rowData) => functions.FormatearFecha(rowData.fechaHasta || "")},
        { title: 'Cantidad disponible', field: 'cantidadDisponible.name', cellStyle:{ maxWidth: '80px'}},
        { title: 'Acción', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Eliminar disponibilidad del listado" handleFunction={()=> removerElemento(rowData)} icon={<DeleteOutlined />} color="red" marginTop={0} fontSize={30} />
                </div>)
            }
            </div>
        },
    ]);

    useEffect(() => {
        showListForm();
    },[])

    const showListForm = async () => {
        setcargandoSolicitud(true);

        const copiaDeCampos = Object.assign({}, elements)
        const {datosDelCanal, datosDeLaRadio} = nuevoTarifario

        let esTercero = "";
        if(tipoMedio && tipoDeMedio[tipoMedio] === 3) esTercero = "catalogoDeEscritos"
        else if(tipoMedio && tipoDeMedio[tipoMedio] === 2) esTercero = Number(datosDeLaRadio?.estaRegistrandoRadio) === 1 ? 1 : 0;
        else esTercero = Number(datosDelCanal?.estaRegistrandoCanal) === 1 ? 1 : 0;

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: catalogoDeEspaciosPorAsignar, saveInStore: false, nombreDelMetodo: "listar", parametro: esTercero}));

        setcargandoSolicitud(false);

        if(respuesta?.error) return setResponseData({ errorType: 'error', messageType: `Ocurrió un incoveniente, intente de nuevo!.`, openResponse: true, });
        if(respuesta?.data?.length === 0) return setResponseData({ errorType: 'error', messageType: `Sin datos del catalogo de espacios por asignar!.`, openResponse: true, });

        const listadoFormateado = respuesta.data?.map( ({id, espacios}) => ({id, name: espacios}) );

        copiaDeCampos.cantidadDisponible.list = functions.ordenarArreglo(listadoFormateado, 'id')
        setElements(copiaDeCampos);
    }

    const agregarDisponibilidadAlListado = () => {

        const newElements = Object.assign({}, elements)
        const patterns = {
            cantidad: '^[1-9][0-9]*$',
            fecha: '^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$'
        }
        const {fechaDesde, fechaHasta, cantidadDisponible} = newElements;

        if(fechaDesde?.value > fechaHasta?.value) return setResponseData({ errorType: 'warning', messageType: `LA FECHA DESDE ES MAYOR A LA FECHA HASTA!.`, openResponse: true, });

        if(!cantidadDisponible.value || !cantidadDisponible.value.id.toString().match(patterns.cantidad)) newElements.cantidadDisponible.isError = true;
        else newElements.cantidadDisponible.isError = false;

        if(!fechaDesde.value || JSON.stringify(fechaDesde.value) === 'null' || !fechaDesde.value.toLocaleDateString('es-ES').match(patterns.fechaDesde)) newElements.fechaDesde.isError = true;
        else newElements.fechaDesde.isError = false;

        if(!fechaHasta.value || JSON.stringify(fechaHasta.value) === 'null' || !fechaHasta.value.toLocaleDateString('es-ES').match(patterns.fechaHasta)) newElements.fechaHasta.isError = true;
        else newElements.fechaHasta.isError = false;

        if(fechaDesde.isError || fechaHasta.isError || cantidadDisponible.isError) return setElements(newElements);

        let elementoActual = "";
        if(dataToValidate.length > 0 ) {
            const existElement = dataToValidate.some((item) => {
                elementoActual = item.fechaHasta;
                return fechaDesde.value <=  item.fechaHasta
            })
            if(existElement) return setResponseData({ errorType: 'warning', messageType: `NO PUEDE INGRESAR UNA FECHA MENOR O IGUAL A ${functions.formatearFechaDD_MM_YYYY(elementoActual)}.`, openResponse: true, });
        }

        setListadoDeDisponibilidades( prevState => [{ id: new Date().getTime(), fechaDesde: fechaDesde.value, fechaHasta: fechaHasta.value, cantidadDisponible: cantidadDisponible.value, posicion: prevState.length + 1}, ...prevState])
        setearFechaMinima(fechaHasta.value, "")
    }

    const setearFechaMinima = (fecha, operacion) => {
        const newElements = Object.assign({}, elements)
        const nuevaFecha = new Date(fecha.getFullYear(), fecha.getMonth(), operacion === 'suma' ? fecha.getDate() + 1 : fecha.getDate());
        newElements.fechaDesde.minDate = nuevaFecha;
        newElements.fechaHasta.minDate = nuevaFecha;
        newElements.fechaDesde.value = nuevaFecha;
        newElements.fechaHasta.value = nuevaFecha;
        setElements(newElements);
    }

    const removerElemento = (rowItem) => {
        setDatosDelElemento(rowItem)
        setMostrarEliminarElemento(true);
    }

    const cerrarModalEliminarElemento = () => setMostrarEliminarElemento(false);

    const accionEliminarElemento = async () => {
        const listadoConElementoELliminado = listadoDeDisponibilidades.filter((item) => item.id !== datosDelElemento.id)
        const listadoMayoresAlElemento = listadoConElementoELliminado.filter( ({posicion}) => posicion > datosDelElemento.posicion);

        if(listadoMayoresAlElemento.length > 0 ) {
            setMostrarEliminarElemento(false);
            return setResponseData({ errorType: 'warning', messageType: `NO PUEDE ELIMINAR LA DISPONIBILIDAD PORQUE TIENE RANGOS DE FECHA MAYORES AL QUE ESTA ELIMINADO!.`, openResponse: true, });
        }

        const newData = listadoConElementoELliminado
        setListadoDeDisponibilidades(newData);
        setMostrarEliminarElemento(false);
        setearFechaMinima(datosDelElemento.fechaDesde, "")
    }

    const calcularPromedio = () => {
        const newElements = Object.assign({}, elements)
        const {julio, agosto, septiembre, octubre, noviembre, diciembre} = elements;
        const promedio = Number(julio?.value) + Number(agosto?.value) + Number(septiembre?.value) + Number(octubre?.value) + Number(noviembre?.value) + Number(diciembre.value)
        newElements.promedio.value = (promedio / 6).toFixed(2);
        setElements(newElements)
    }

    const [elements, setElements] = React.useState({
        tarifario:{
            idelement: "tarifario", title:'Tarifario', position:"center", elementType:'titulo', showTitleForm: true, name: "tarifario", value: "", isError:false,
        }, 
        alertaSpots:{
            idelement: "alertaSpots", mensaje: title || 'PROMEDIO DE TARIFA COMERCIAL DE SPOTS DE 20 SEGUNDOS DE LOS ÚLTIMOS SEIS MESES', elementType:'alerta', showAlertForm: true, name: "alertaSpots", value: "", isError:false, severity: 'error'
        },
        alertaTarifa:{
            idelement: "alertaTarifa", mensaje: subtitle || 'LA TARIFA DEBE SER INGRESADA EN QUETZALES(Q) Y NO DEBE INCLUIR IVA NI TIMBRE DE PRENSA(SE CALCULARÁ AL TENER DEFINIDA LA TARIFA ELECTORAL)', elementType:'alerta', showAlertForm: true, name: "alertaTarifa", value: "", isError:false, severity: 'error'
        },
        tarifaComercial:{
            idelement: "tarifaComercial", title: 'Ingrese la Tarifa Comercial', position:"center", elementType:'titulo', showTitleForm: true, name: "tarifaComercial", value: "", isError:false,
        },
        julio: {
            idelement: "julio",  value: julio, label: "JUL *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"julio", 'disabled': false, width: '14%', manejadorDeCambio: calcularPromedio
        },
        agosto: {
            idelement: "agosto",  value: agosto, label: "AGO *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"agosto", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
        },
        septiembre: {
            idelement: "septiembre",  value: septiembre, label: "SEP *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"septiembre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
        },
        octubre: {
            idelement: "octubre",  value: octubre, label: "OCT *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"octubre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
        },
        noviembre: {
            idelement: "noviembre",  value: noviembre, label: "NOV *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"noviembre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
        },
        diciembre: {
            idelement: "diciembre",  value: diciembre, label: "DIC *", pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diciembre", 'disabled': false, width: '14%',  manejadorDeCambio: calcularPromedio
        },
        promedio: {
            idelement: "promedio",  value: promedio, label: "PROMEDIO *", pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"promedio", 'disabled': true, width: '14%'
        },
        tituloDisponibilidad:{
            idelement: "tituloDisponibilidad", title:'Disponibilidad', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloDisponibilidad", value: "", isError:false,
        },
        alertaDisponibilidad:{
            idelement: "alertaDisponibilidad", mensaje: titleDisponibilidad || 'LA DISPONIBILIDAD MINIMA SOLICITADA ES DE 160 SPOTS DE 20 SEGUNDOS POR CADA DÍA DISPONIBLE.', elementType:'alerta', showAlertForm: true, name: "alertaDisponibilidad", value: "", isError:false, severity: 'error'
        },
        fechaDesde: {
            idelement: "fechaDesde", value: null, label: "DESDE: *", pattern:"",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false, width: '30%', minDate: new Date()
        },
        fechaHasta: {
            idelement: "fechaHasta", value: null, label: "HASTA *", pattern:"",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false, width: '30%', minDate: new Date()
        },
        cantidadDisponible: {
            idelement: "cantidadDisponible", value: null , label: "Cantidad por día disponible *", pattern:"", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '30%', marginTop: '1%'
        },
        boton:{
            idelement: "boton", elementType:'boton', name: "boton", value: "", isError:false, icon: "add_circle", handleFunction: agregarDisponibilidadAlListado, title: "Agregar disponibilidad al listado", color: "#53C22B"
        },
        acciones: {
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose();
    };

    const siguientePaso = async (dataForm) => {

        if(dataToValidate.length === 0) {
            return setResponseData({ errorType: 'warning', messageType: `DEBE DE INGRESAR AL MENOS UNA DISPONIBILIDAD!.`, openResponse: true, });
        }

        dataForm.disponibilidades = dataToValidate

        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_TARIFARIO_Y_DISPONIBILIDAD,
            data: {
                tarifarioYDisponibilidad: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const regresar = (dataForm) => {
        dataForm.disponibilidades = dataToValidate
        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_TARIFARIO_Y_DISPONIBILIDAD,
            data: {
                tarifarioYDisponibilidad: dataForm,
                activeStep : activeStep - 1,
                numberStep : numberStep - 1
            }
        }));
    };

    const [buttonList]= React.useState({
        "regresar":{"label":"Regresar", "icon": <NavigateBefore />,"callback":regresar,"loading":false,"size":"medium",
            "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
            "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false, isCancel: true,
        },
        "siguientePaso":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <NavigateNext />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => {
        setResponseData({errorType,messageType,openResponse,})
    };

    const { errorType, messageType, openResponse} = responseData;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonList}
                    />
                    <TablaPersonalizada
                        pageSize={5}
                        data={listadoDeDisponibilidades}
                        title={"Listado de disponibilidades"}
                        header={header}
                    />
                </CardContent>
            </Card>
            {mostrarEliminarElemento && (
                    <Modal
                        title={`¿Está seguro de eliminar la disponibilidad?`} message={"No podrá revertir esta acción"}
                        open={mostrarEliminarElemento} closeModal={cerrarModalEliminarElemento} titleButton={"Sí, estoy seguro"}
                        actionAdd={accionEliminarElemento}
                    />
                )}
        </Fragment>
    );
}

export default TarifarioYDisponibilidad;